import SearchParamsBase from "../../../Elements/SearchParamsBase";
import InputTypesEnum from "../../../Enums/InputTypesEnum";

export default class CaspianXxApiQuerySearchParams extends SearchParamsBase
{
	initialize()
	{
		this.SftpDataId="";
		this.Host="";
		this.UserName="";
		this.ServerName="";
		this.IsActive=""
	}

	//-------------------------------------------
	//-------- Fields for Search Panel ----------
	//-------------------------------------------

	static fieldsInSearchBox=[
		{fieldName:"SftpDataId",label:"SftpData Id", className:"col-3", type: InputTypesEnum.Number},
		{fieldName:"Host",label:"Host", className:"col-3", type: InputTypesEnum.Number},
		{fieldName:"UserName",label:"User Name", className:"col-3", type: InputTypesEnum.Number},
		{fieldName:"ServerName",label:"Server Name", className:"col-3", type: InputTypesEnum.Text},
		{fieldName:"IsActive",label:"Is Active", className:"col-3", type: InputTypesEnum.EmptyYesNoSelect},
	];

	static iconName="fa-solid fa-search";
	static saveType = "CaspianXxApiQuerySearchParams";

	//---------------------------
	
}